import React from 'react'
import Paper from '@mui/material/Paper'

class About extends React.Component{

	constructor(props){
super(props)
	}

	render(){
		return (
<Paper sx={{margin:1,pt:6}}>
<h2>About</h2>
</Paper>

			)
	}
}

export default About;